import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { Nullable } from '@utils/util.types';
import { Channel, ChannelType } from '../types';
import { ChannelItem } from '../ChatSidebar/ChannelList';

interface ChannelListProps {
	channels: Channel[];
	selectedChannelId: Nullable<string>;
	onChannelSelect: (channelId: string, channelType: ChannelType) => void;
	isLoading?: boolean;
	loadingText?: string;
	emptyStateText?: string;
	onRefresh?: () => void;
}

export const ChannelList: React.FC<ChannelListProps> = ({
	channels,
	selectedChannelId,
	onChannelSelect,
	isLoading = false,
	loadingText,
	emptyStateText = 'No channels available',
	onRefresh,
}) => {
	if (isLoading && channels.length === 0) {
		return (
			<Box display="flex" justifyContent="center" p={2}>
				<CircularProgress size={20} />
				{loadingText && <Box ml={1}>{loadingText}</Box>}
			</Box>
		);
	}

	if (channels.length === 0) {
		return (
			<Box display="flex" justifyContent="center" p={2}>
				<Box>
					{emptyStateText}
					{onRefresh && (
						<Box
							component="button"
							sx={{
								ml: 1,
								color: 'primary.main',
								border: 'none',
								background: 'none',
								cursor: 'pointer',
							}}
							onClick={onRefresh}
						>
							Refresh
						</Box>
					)}
				</Box>
			</Box>
		);
	}

	return (
		<>
			{channels.map((channel) => (
				<ChannelItem
					key={channel.id}
					channel={channel}
					lastMessage={channel.getLastMessageContent()}
					isSelected={channel.id === selectedChannelId}
					onClick={() => onChannelSelect(channel.id, channel.channelType)}
				/>
			))}
		</>
	);
}; 